import { MINIMAP_CONFIG } from './../constants/game'
// import Phaser from 'phaser'
// import MapComponent from './map'

export default class MinimapComponent {
  /** @type { Phaser.Cameras.Scene2D.Camera } */
  minimap

  /** @type {{context: Phaser.Scene, toMap: MapComponent }} */
  config = {}

  /**
   *
   * @param { Phaser.Scene } context
   * @param { MapComponent } toMap
   *
   */
  constructor(context, toMap) {
    this.config.context = context
    this.config.toMap = toMap
  }

  // LOAD assets
  preload() { 
  }

  create() { 
    const MEDIA_TYPE = this.config.context.data.get('mediaType')
    const RELATION_RATE = MINIMAP_CONFIG.relation[MEDIA_TYPE]

    const MINI_MAP_DIMENTIONS = {
      width: this.config.toMap.map.displayWidth * RELATION_RATE,
      height: this.config.toMap.map.displayHeight * RELATION_RATE,
    }
    this.minimap = this.config.context.cameras
      .add(
        MINIMAP_CONFIG.posX[MEDIA_TYPE],
        MINIMAP_CONFIG.posY[MEDIA_TYPE],
        MINI_MAP_DIMENTIONS.width,
        MINI_MAP_DIMENTIONS.height
      )
      .setZoom(RELATION_RATE)
      .setOrigin(0)
      .setName('minimap')
      .setVisible(false)
    
    /* WONT SHOW MINI MAP THIS TIME
    // ## DEFINE BORDER STYLE
    const MINIMAP_BORDER_KEY = `${this.config.context.scene.key}-minima-border`
    const MINIMAP_BORDER_WEIGHT = MINIMAP_CONFIG.borderWeight[MEDIA_TYPE]

    const minimapWrapDimentions = {
      width: this.minimap.width + MINIMAP_BORDER_WEIGHT * 2,
      height: this.minimap.height + MINIMAP_BORDER_WEIGHT * 2,
    }
    this.config.context.make
      .graphics({
        x: 0,
        y: 0,
        add: false,
      })
      .fillStyle(MINIMAP_CONFIG.borderColor, MINIMAP_CONFIG.borderOpacity)
      .fillRect(0, 0, minimapWrapDimentions.width, minimapWrapDimentions.height)
      .generateTexture(
        MINIMAP_BORDER_KEY,
        minimapWrapDimentions.width,
        minimapWrapDimentions.height
      )
    this.config.context.add
      .image(
        MINIMAP_CONFIG.posX[MEDIA_TYPE] - MINIMAP_BORDER_WEIGHT,
        MINIMAP_CONFIG.posY[MEDIA_TYPE] - MINIMAP_BORDER_WEIGHT,
        MINIMAP_BORDER_KEY
      )
      .setOrigin(0)
      .setDepth(MINIMAP_CONFIG.borderDepth)
      .setScrollFactor(0).cameraFilter = this.minimap.id

      */
  }
}
